import { render } from "./ConfigurationValue.vue?vue&type=template&id=1bb75f3e&scoped=true"
import script from "./ConfigurationValue.vue?vue&type=script&lang=js"
export * from "./ConfigurationValue.vue?vue&type=script&lang=js"

import "./ConfigurationValue.vue?vue&type=style&index=0&id=1bb75f3e&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb75f3e"]])

export default __exports__